import PolicyLayout from './PolicyLayout';
import { COMPANY_NAME, SITE_DOMAIN, SUPPORT_EMAIL } from '../constants/site';

export default function RefundPolicy() {
  return (
    <PolicyLayout
      title="Refund Policy"
      updated="1 August 2026"
      intro={`We want you protected and satisfied. This Refund Policy sets out when you can request your money back on a purchase made through ${SITE_DOMAIN}, operated by ${COMPANY_NAME}, how to request it, and how long it takes to reach your account.`}
    >
      <h2>30-Day Money-Back Guarantee</h2>
      <p>
        Software licences purchased from us are covered by a thirty-day money-back guarantee, counted
        from the date of purchase shown on your receipt. If the product does not work as described,
        or you simply change your mind, contact us within that window for a full refund.
      </p>

      <h2>Eligibility</h2>
      <p>A refund request qualifies when all of the following apply:</p>
      <ul>
        <li>The request is made within thirty days of the original purchase date.</li>
        <li>The licence key was purchased directly from {SITE_DOMAIN}.</li>
        <li>You can supply the order reference or the email address used at checkout.</li>
        <li>
          The key has not been used in breach of these terms, for example resold or shared beyond
          your household.
        </li>
      </ul>

      <h2>What Is Not Refundable</h2>
      <p>The following fall outside the guarantee:</p>
      <ul>
        <li>Requests made more than thirty days after purchase.</li>
        <li>
          Subscription renewals where a reminder was sent and no cancellation was received before
          the renewal date.
        </li>
        <li>
          One-off technical support sessions that were completed successfully and delivered the
          agreed outcome.
        </li>
        <li>
          Purchases where fraudulent payment details or a chargeback dispute has been raised without
          contacting us first.
        </li>
      </ul>

      <h2>Partial Refunds</h2>
      <p>
        Where a multi-year subscription is cancelled after the first term has begun, we may issue a
        pro-rata refund for complete unused months at our discretion. Any discount originally
        applied to the bundle is deducted from the refundable amount.
      </p>

      <h2>How to Request a Refund</h2>
      <p>
        Email <strong>{SUPPORT_EMAIL}</strong> or call our support desk with your order reference and
        a short description of the issue. Wherever possible we will first try to resolve the problem
        — most refund requests come from an installation issue that we can fix in a single call. If
        you still want to proceed, we process the refund without further questions.
      </p>

      <h2>Processing Time</h2>
      <p>
        Approved refunds are submitted to your payment provider within two business days. Funds
        typically appear on your statement within seven to ten business days, though the exact
        timing depends on your bank or card issuer. Refunds are always returned to the original
        payment method; we cannot redirect them to a different card or account.
      </p>

      <h2>Cancelling Automatic Renewal</h2>
      <p>
        Subscriptions renew automatically so your protection never lapses. You can cancel automatic
        renewal at any time by contacting us before the renewal date. Cancelling stops future
        charges but does not shorten the term you have already paid for — your protection continues
        until the current period ends.
      </p>

      <h2>Chargebacks</h2>
      <p>
        Please contact us before raising a dispute with your bank. Chargebacks filed without prior
        contact can freeze the associated licence and delay resolution considerably. In almost every
        case a direct refund is faster than a formal dispute.
      </p>

      <h2>Policy Updates</h2>
      <p>
        This policy may be revised periodically. The version in effect on the date of your purchase
        is the one that applies to your order, regardless of later changes.
      </p>
    </PolicyLayout>
  );
}
